// extracted by mini-css-extract-plugin
export default {"colorcomplete":"#62c6c4","colorincomplete":"#ffa600","chartContainerStyle":"SuccessfulRunsChart_chartContainerStyle__zlqwJ"};